/* RG seurantakerros: julkaisee yhteydenottotapahtumat Shopifyn asiakastapahtumiin (Shopify.analytics.publish),
   joista custom pixel (Asetukset → Asiakastapahtumat) välittää ne GA4:ään suostumuksen mukaan. Ei henkilötietoja:
   lomakkeista lähetetään vain lomakkeen tunniste ja valittu toive, ei nimiä, sähköposteja tai viestejä. */
(function () {
  'use strict';
  function publish(name, data) {
    try { if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') window.Shopify.analytics.publish(name, data || {}); } catch (e) {}
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: name }, data || {})); } catch (e) {}
  }
  function page() { return { page_path: location.pathname, page_lang: document.documentElement.lang || '' }; }
  // 1) Puhelin- ja sähköpostilinkit
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="tel:"], a[href^="mailto:"]');
    if (!a) return;
    var href = a.getAttribute('href');
    publish(href.indexOf('tel:') === 0 ? 'rg_phone_click' : 'rg_email_click', Object.assign({ link_domain: href.replace(/^(tel:|mailto:)/, '').replace(/^[^@]*@/, ''), link_text: (a.textContent || '').trim().slice(0, 60) }, page()));
  }, true);
  // 2) Tarjouspyyntö- ja hinnastolinkit (yhteydenottosivulle vievät CTA:t)
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href*="/pages/contact"]');
    if (!a) return;
    var u; try { u = new URL(a.href, location.origin); } catch (err) { return; }
    var kind = /tukkuhinnasto|hinnasto/i.test(u.search + a.textContent) ? 'rg_pricelist_cta' : (u.searchParams.get('tuote') ? 'rg_quote_cta' : 'rg_contact_cta');
    publish(kind, Object.assign({ cta_text: (a.textContent || '').trim().slice(0, 60), product: u.searchParams.get('tuote') || '' }, page()));
  }, true);
  // 3) Lomakkeiden lähetys (Shopifyn contact-lomakkeet): vain lomakkeen tunniste ja toive
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!(f instanceof HTMLFormElement) || !/\/contact/.test(f.getAttribute('action') || '')) return;
    var wish = f.querySelector('[name="contact[Toive]"], [name="contact[Aihe]"], [name="contact[aihe]"]');
    var src = f.querySelector('[name="contact[Lähde]"]');
    publish('rg_form_submit', Object.assign({ form_id: f.id || 'contact', form_source: src ? src.value : '', form_wish: wish ? (wish.value || '').slice(0, 60) : '' }, page()));
  }, true);
  // 4) Onnistunut lähetys (Shopify palauttaa ?contact_posted=true)
  if (/[?&]contact_posted=true/.test(location.search)) publish('rg_form_success', page());
  // 5) Suodattimen ja valitsimen käyttö (kevyt käyttökokemustieto, ei henkilötietoja)
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('.rg-gf__chip'); if (chip) publish('rg_filter_use', Object.assign({ group: chip.dataset.group || '', value: (chip.dataset.value || '').slice(0, 40) }, page()));
    var pk = e.target.closest('[data-pk]'); if (pk) publish('rg_picker_use', Object.assign({ value: pk.getAttribute('data-pk') || 'all' }, page()));
    var hs = e.target.closest('[data-rgb-hs]'); if (hs) publish('rg_hotspot_open', Object.assign({ index: hs.getAttribute('data-rgb-hs') }, page()));
  }, true);
})();
